export default __webpack_public_path__ + "0ca9b0624c3adc740900d3582a8c0781.png";